const rutasClientes = {
  path: "clientes",
  name: 'clientes',
  redirect: {
    name: 'clientes-index'
  },
  component: () =>
    import(
      /* webpackChunkName: "Dashboard-Clientes-Root" */ "@/modules/dashboard/pages/clientes"
    ),
  children: [
    {
      path: "",
      name: "clientes-index",
      component: () =>
        import(
          /* webpackChunkName: "Dashboard-Clientes" */ "@/modules/dashboard/pages/clientes/ClientesPage"
        ),
    },
    {
      path: "crear",
      name: "crear-cliente",
      component: () =>
        import(
          /* webpackChunkName: "Dashboard-Clientes-Create" */ "@/modules/dashboard/pages/clientes/CreateClientePage"
        ),
    },
    {
      path: ":cliente_id/editar",
      name: "editar-cliente",
      component: () =>
        import(
          /* webpackChunkName: "Dashboard-Clientes-Edit" */ "@/modules/dashboard/pages/clientes/EditClientePage"
        ),
    },
  ],
};

export default rutasClientes;